/**
 * RailSelectorContainer component.
 */
import styled from 'styled-components';
import withAnimation from '../../../../shared/components/utils/hoc/withAnimation';

/**
 * Styled rail selector container.
 */
const RailSelectorContainer = styled.div<React.CSSProperties>``;

export default withAnimation(RailSelectorContainer);
